import { Link } from 'react-router-dom';

// material-ui
import { Box, Button, Container, Grid, Stack, Typography } from '@mui/material';

// project-imports
import { APP_DEFAULT_PATH } from 'config';

// assets
import maintenance from 'assets/images/maintenance/img-cunstruct-1.svg';
import maintenanceBg from 'assets/images/maintenance/img-cunstruct-1-bg.png';
import maintenanceBottom from 'assets/images/maintenance/img-cunstruct-1-bottom.svg';

// ==============================|| SITE DISABLED ||============================== //

function SiteDisabled() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: `url(${maintenanceBg})`,
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <Container
        fixed
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Grid
          container
          spacing={3}
          alignItems="center"
          justifyContent="center"
          sx={{
            py: 2,
            backgroundImage: `url(${maintenanceBottom})`,
            backgroundSize: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'bottom'
          }}
        >
          <Grid
            item
            md={6}
          >
            <Stack
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Typography
                align="center"
                variant="h1"
              >
                Site Desabilitado
              </Typography>
              <Typography
                color="textSecondary"
                align="center"
                sx={{ width: '85%' }}
              >
                Este site está temporariamente desabilitado. Por favor, tente novamente mais tarde ou entre em contato
                com o suporte.
              </Typography>
              <Button
                component={Link}
                to={APP_DEFAULT_PATH}
                variant="contained"
              >
                Entre em contato
              </Button>
            </Stack>
          </Grid>
          <Grid
            item
            md={6}
          >
            <Box sx={{ width: { xs: 300, sm: 374 } }}>
              <img
                src={maintenance}
                alt="site disabled"
                style={{ width: '100%', height: 'auto' }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default SiteDisabled;
